import { EventEmitter } from '@angular/core';
import { CommunicationService } from '../../../services/communication/communication.service';
import { UserService } from '../../../services/user.service';
import { timer } from 'rxjs/observable/timer';
import { concatMap } from 'rxjs/operators';
import { DateUtils } from '../../../utils/date.utils';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonConstant } from '../../../app.constants';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StringUtils } from '../../../utils/string.utils';
import { ContactPermissionStatus } from '../../../../models/influencer';
import { TranslateService } from '@ngx-translate/core';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { EventTrackerService, UserActionType, Page, ActionSource, TargetType } from '../../../services/event-tracker/event-tracker.service';
import { AppSettings } from '../../../utils/app-settings';
var InfluencerChatComponent = /** @class */ (function () {
    function InfluencerChatComponent(conversationService, userService, modalService, deviceService, influencerService, translate, eventTracker, router, activatedRoute) {
        this.conversationService = conversationService;
        this.userService = userService;
        this.modalService = modalService;
        this.deviceService = deviceService;
        this.influencerService = influencerService;
        this.translate = translate;
        this.eventTracker = eventTracker;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.REQUEST_PERMISSION_MESSAGE_ID = -1;
        this.showActivityLog = true;
        this.showActivityLogChange = new EventEmitter();
        this.afterReadLastMessage = new EventEmitter();
        this.newMessageAdded = new EventEmitter();
        this.inputMessageContent = '';
        this.messageList = [];
        // current page no
        this.pageNo = 0;
        // this flag is using to determine whether scrolling to oldest message
        this.reachLastPage = false;
        // this flag is using to determine whether user read the latest message
        this.isReadLastMessage = false;
        this.isError = false;
        this.hasAutoReplyMessage = false;
        this.scrollCallback = this.onScrollUp.bind(this);
        this.handleScrollDataCallback = this.handleNextMessages.bind(this);
    }
    InfluencerChatComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.conversation && this.hasChangedConvo(changes.conversation.previousValue, changes.conversation.currentValue)) {
            if (this.pollingSubscription) {
                this.pollingSubscription.unsubscribe();
            }
            this.messageList = [];
            this.pageNo = 0;
            this.reachLastPage = false;
            this.conversationService.fetchConversationDetails(this.userService.getCompanyId(), this.conversation.id, this.pageNo).subscribe(function (res) {
                _this.conversation.permission = res.permission;
                _this.conversation.participants = res.participants;
                if (res && res.messages.length > 0) {
                    _this.lastActivity = res.messages[res.messages.length - 1].sentTime;
                    // if component already initialized, manually added message of new convo
                    if (changes.conversation.previousValue) {
                        _this.handleNextMessages(res.messages);
                    }
                }
                _this.pollingNewMessage(_this.conversation);
            });
        }
    };
    InfluencerChatComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.getCurrentUserInfo().subscribe(function (res) {
            if (res && res.data) {
                _this.currentUserInfo = res.data;
            }
        });
        this.isCommunicationPage = this.router.url.indexOf('inbox') >= 0;
        this.activatedRoute.queryParams.subscribe(function (qp) {
            _this.isLandingPageMode = AppSettings.isActiveNewCampaignFlow() && (qp.accessToken || qp.inviteToken);
        });
        if (this.conversation && this.conversation.messages.length > 0) {
            this.lastActivity = this.conversation.messages[this.conversation.messages.length - 1].sentTime;
        }
    };
    InfluencerChatComponent.prototype.ngOnDestroy = function () {
        if (this.pollingSubscription) {
            this.pollingSubscription.unsubscribe();
        }
    };
    InfluencerChatComponent.prototype.pollingNewMessage = function (conversation) {
        // only poll when contact permission has been accepted
        if (this.userService.isInfluencer || this.isAcceptedPermission(conversation)) {
            this.pollNewMessageUntilFinish(this.userService.getCompanyId(), conversation.id);
        }
    };
    InfluencerChatComponent.prototype.onShowActivityLogChange = function (value) {
        this.showActivityLogChange.emit(value);
    };
    InfluencerChatComponent.prototype.isIncommingMessage = function (message) {
        return message.type === 1 /* InComming */;
    };
    InfluencerChatComponent.prototype.isOutgoingMessage = function (message) {
        return message.type === 2 /* OutGoing */;
    };
    InfluencerChatComponent.prototype.isCampaignMessage = function (message) {
        return message.type === 3 /* Invitation */;
    };
    InfluencerChatComponent.prototype.isContactPermissionMessage = function (message) {
        return message.messageType === "ACCEPTED_PERMISSION" /* accepted */ ||
            message.messageType === "REQUESTED_PERMISSION" /* requested */ ||
            message.messageType === "REJECTED_PERMISSION" /* rejected */;
    };
    InfluencerChatComponent.prototype.isShowSendButton = function () {
        return !!(this.inputMessageContent + '').trim().length;
    };
    InfluencerChatComponent.prototype.onKeyDown = function (evt) {
        if (this.conversation && this.conversation.isHidden) {
            return;
        }
        if (evt.keyCode === 13 && StringUtils.trim(this.inputMessageContent) !== '') {
            if (this.inputMessageContent.length > InfluencerChatComponent.MAX_LENGTH_MESSAGE) {
                this.modalService.open(this.alertMessageTooLong, null, true);
                return;
            }
            this.sendMessage(this.userService.getCompanyId(), this.conversation.id, this.inputMessageContent);
        }
    };
    InfluencerChatComponent.prototype.onSendMessage = function (messageContent) {
        if (!messageContent) {
            if (this.inputMessageContent.length > InfluencerChatComponent.MAX_LENGTH_MESSAGE) {
                this.modalService.open(this.alertMessageTooLong, null, true);
                return;
            }
            this.sendMessage(this.userService.getCompanyId(), this.conversation.id, this.inputMessageContent);
        }
        else {
            this.sendMessage(this.userService.getCompanyId(), this.conversation.id, messageContent, true);
        }
    };
    InfluencerChatComponent.prototype.retryOnError = function (errorMessage) {
        if (!errorMessage) {
            return;
        }
        errorMessage.isSending = true;
        this.isError = false;
        this.sendMessage(this.userService.getCompanyId(), this.conversation.id, errorMessage.content, true);
    };
    InfluencerChatComponent.prototype.sendMessage = function (companyId, conversationId, message, isRetried) {
        var _this = this;
        if (!isRetried) {
            this.sendMixpanel();
            this.resetChatField();
            // when user reply, it mean that they already read all new messages
            this.onReadLastMessage();
            this.scrollToBottom();
            var newMessage = {
                id: 0,
                conservationId: conversationId,
                sender: {
                    id: companyId,
                    name: null,
                    company: null,
                    influencer: null,
                    lastSeenMessage: null,
                    user: null
                },
                content: message,
                type: 2 /* OutGoing */,
                isSending: true,
                recipientName: null,
                sentTime: String(DateUtils.now().getTime())
            };
            this.messageList.push(newMessage);
        }
        this.isError = false;
        this.conversationService.sendMessage(companyId, conversationId, message).subscribe(function (res) {
            if (!res || !res.message) {
                return;
            }
            if (_this.userService.isInfluencer) {
                _this.buildAutoReplyMessage(res.message.date);
            }
            _this.afterSendingNewMessage(res.message, false);
        }, function (error) {
            _this.afterSendingNewMessage(null, true);
        });
    };
    InfluencerChatComponent.prototype.afterSendingNewMessage = function (persistedMessage, isError) {
        var newMessage = this.messageList.find(function (msg) { return msg.isSending && msg.id === 0; });
        if (!newMessage) {
            return;
        }
        newMessage.isSending = false;
        if (isError) {
            this.isError = true;
        }
        else if (persistedMessage) {
            newMessage.id = persistedMessage.id;
            newMessage.sender = persistedMessage.participant;
            newMessage.sentTime = persistedMessage.date;
        }
    };
    InfluencerChatComponent.prototype.onScrollUp = function () {
        if (!this.reachLastPage && this.conversation.id > 0) {
            return this.conversationService.fetchConversationDetails(this.userService.getCompanyId(), this.conversation.id, this.pageNo)
                .map(function (res) { return res ? res.messages : []; });
        }
    };
    InfluencerChatComponent.prototype.handleNextMessages = function (messages) {
        (_a = this.messageList).splice.apply(_a, [0, 0].concat(messages));
        this.reachLastPage = Array.isArray(messages) && messages.length === 0;
        // if this is the first page, scroll to last message
        if (this.pageNo === 0) {
            this.scrollToBottom();
        }
        this.pageNo += 1;
        var _a;
    };
    InfluencerChatComponent.prototype.resetChatField = function () {
        this.inputMessageContent = null;
    };
    InfluencerChatComponent.prototype.scrollToBottom = function () {
        var _this = this;
        setTimeout(function () {
            var messageContainer = document.querySelector('.message-history');
            if (messageContainer) {
                var messageDomList = messageContainer.querySelectorAll('.message');
                if (messageDomList.length > 0) {
                    var lastMsgElement = messageDomList[messageDomList.length - 1];
                    if (_this.deviceService.isMobile()) {
                        $('html').animate({
                            scrollTop: lastMsgElement.offsetTop
                        }, 10);
                    }
                    else {
                        messageContainer.scrollTop = lastMsgElement.offsetTop;
                    }
                }
            }
        }, 200);
    };
    InfluencerChatComponent.prototype.pollNewMessageUntilFinish = function (companyId, conversationId) {
        var _this = this;
        if (!conversationId || conversationId <= 0) {
            return;
        }
        this.pollingSubscription = timer(0, 5000)
            .pipe(concatMap(function () { return _this.conversationService.fetchNewMessages(companyId, conversationId, _this.lastActivity); }))
            .subscribe(function (res) {
            if (Array.isArray(res) && res.length > 0) {
                var existingMessageIds_1 = _this.messageList.map(function (msg) { return msg.id; });
                var newMessages = res.filter(function (msg) { return msg.id > 0 && existingMessageIds_1.indexOf(msg.id) < 0; });
                _this.messageList = _this.messageList.concat(newMessages);
                _this.conversation.messages = _this.messageList;
                _this.lastActivity = res[res.length - 1].sentTime;
                _this.scrollToBottom();
                var newMessageUnread = res.filter(function (msg) { return msg.sender && msg.sender.company.id !== companyId; });
                if (res.length > 0) {
                    _this.isReadLastMessage = false;
                    _this.newMessageAdded.emit({
                        conversationId: _this.conversation.id,
                        status: newMessageUnread.length > 0 ? 1 /* Warning */ : 0 /* Normal */,
                        lastMessage: res[res.length - 1]
                    });
                }
            }
        });
    };
    InfluencerChatComponent.prototype.openCampaignDetails = function (campaignId, campaignInfluencerId, status) {
        var currentInfluencer = this.userService.getInfluencerInfo();
        // login as influencer
        if (currentInfluencer) {
            if (this.isActiveCampaign(status) && this.deviceService.isDesktop()) {
                return this.router.navigate(['dashboard', 'campaigns', campaignInfluencerId, 'active']);
            }
            else {
                return this.router.navigate(['dashboard', 'campaigns', campaignId, 'new']);
            }
        }
        else {
            return this.router.navigate(['campaigns', campaignId]);
        }
    };
    InfluencerChatComponent.prototype.onReadLastMessage = function () {
        var _this = this;
        if (this.isReadLastMessage) {
            return;
        }
        var unReadMessages = this.messageList.filter(function (msg) { return ((msg.sender && msg.sender.company && msg.sender.company.id !== _this.userService.getCompanyId()) || (msg.type === 1 /* InComming */)); });
        if (unReadMessages.length === 0) {
            this.isReadLastMessage = true;
            return;
        }
        this.afterReadLastMessage.emit({
            conversationId: this.conversation.id,
            lastMessageId: unReadMessages[unReadMessages.length - 1].id,
            callback: function () {
                _this.isReadLastMessage = true;
            }
        });
    };
    InfluencerChatComponent.prototype.getSenderName = function (msg) {
        if (!this.showActivityLog || !msg.sender) {
            return '';
        }
        return msg.sender.influencer ? msg.sender.influencer.name + " - " : msg.sender.user ? msg.sender.user.fullName + " - " : '';
    };
    InfluencerChatComponent.prototype.getCampaignMessageStatus = function (mess) {
        if (mess.content.indexOf('Declined') >= 0 || mess.content.indexOf('Invited') >= 0
            || mess.content.indexOf('Accepted') >= 0 || mess.content.indexOf('Interested') >= 0) {
            return '';
        }
        else if (mess.messageType === "REQUESTED_PERMISSION" /* requested */) {
            return mess.status = 'requested';
        }
        else if (mess.messageType === "ACCEPTED_PERMISSION" /* accepted */) {
            return mess.status = 'accepted';
        }
        else if (mess.messageType === "REJECTED_PERMISSION" /* rejected */) {
            return mess.status = 'rejected';
        }
        else {
            return mess.status;
        }
    };
    Object.defineProperty(InfluencerChatComponent.prototype, "isMessageTooLong", {
        get: function () {
            return this.inputMessageContent && this.inputMessageContent.length > InfluencerChatComponent.MAX_LENGTH_MESSAGE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerChatComponent.prototype, "shouldShowChatBox", {
        get: function () {
            if (this.userService.isAdmin) {
                return true;
            }
            this.conversation.isHidden = false;
            return this.conversation;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerChatComponent.prototype.numberCharacterOver = function (mess) {
        if (!mess) {
            return 0;
        }
        return mess.length - InfluencerChatComponent.MAX_LENGTH_MESSAGE;
    };
    InfluencerChatComponent.prototype.isAcceptedPermission = function (conversation) {
        return conversation.permission === ContactPermissionStatus.ACCEPTED;
    };
    InfluencerChatComponent.prototype.isRejectedPermission = function (conversation) {
        return conversation.permission === ContactPermissionStatus.REJECTED;
    };
    InfluencerChatComponent.prototype.isNotRequestPermission = function (conversation) {
        return !this.userService.isInfluencer && conversation.permission === ContactPermissionStatus.UNDEFINED;
    };
    InfluencerChatComponent.prototype.isRequestedPermission = function (conversation) {
        return !this.userService.isInfluencer && conversation.permission === ContactPermissionStatus.REQUESTED;
    };
    InfluencerChatComponent.prototype.canSendMessage = function (conversation) {
        if (!conversation) {
            return false;
        }
        // influencer can send message without permission
        if (this.userService.isInfluencer) {
            return true;
        }
        return conversation.permission === ContactPermissionStatus.ACCEPTED && !conversation.isHidden && conversation.isJoined;
    };
    InfluencerChatComponent.prototype.sendPermissionRequest = function (conversation) {
        var _this = this;
        this.sendMixpanel();
        if (this.userService.isAdmin) {
            this.modalService.openInCenter(this.adminEditConversationAlert);
            return;
        }
        var participant = conversation.participants.find(function (p) { return p.influencer; });
        var influencerId = this.influencerId ? this.influencerId : participant ? participant.influencer.id : null;
        if (influencerId) {
            this.conversation.permission = ContactPermissionStatus.REQUESTED;
            this.buildContactPermissionRequest(conversation);
            this.pollNewMessageUntilFinish(this.userService.getCompanyId(), conversation.id);
            this.influencerService.requestPermission(this.userService.getCompanyId(), influencerId).subscribe(function (res) {
                // do nothing
            }, function (error) {
                _this.serverErrorMessage = _this.getPermissionRequestErrorMessage(error.error);
                _this.modalService.open(_this.serverErrorNotification, null, true);
                // revert to previous status
                // revert request permission message
                _this.conversation.permission = ContactPermissionStatus.UNDEFINED;
                conversation.messages = conversation.messages.filter(function (m) { return m.id !== _this.REQUEST_PERMISSION_MESSAGE_ID; });
                _this.messageList = conversation.messages;
            });
        }
    };
    InfluencerChatComponent.prototype.getPermissionRequestErrorMessage = function (error) {
        var errorCode = error && error.error_code;
        if (errorCode === 'duplicate_request') {
            return this.translate.instant('inbox.duplicate_request_permission_error');
        }
        if (errorCode === 'invalid_company' || errorCode === 'invalid_influencer') {
            return this.translate.instant('inbox.invalid_request_permission_error');
        }
        return this.translate.instant('inbox.send_request_error');
    };
    InfluencerChatComponent.prototype.getPermissionMessage = function (conversation) {
        if (this.userService.isInfluencer) {
            return this.translate.instant('inbox.influencer_not_accept_permission_yet');
        }
        if (this.isRejectedPermission(conversation)) {
            return this.translate.instant('inbox.permission_rejected_message');
        }
        if (!this.isAcceptedPermission(conversation)) {
            return this.translate.instant('inbox.await_influencer_accept_permission');
        }
        return null;
    };
    InfluencerChatComponent.prototype.needPermission = function (conversation) {
        // influencer don't need permission to send message
        if (this.userService.isInfluencer) {
            return false;
        }
        return (conversation.permission === ContactPermissionStatus.REQUESTED
            || conversation.permission === ContactPermissionStatus.UNDEFINED
            || conversation.permission === ContactPermissionStatus.REJECTED) && conversation.isJoined;
    };
    InfluencerChatComponent.prototype.closePopup = function () {
        this.modalService.close();
    };
    InfluencerChatComponent.prototype.isActiveCampaign = function (status) {
        if (!status) {
            return false;
        }
        return status.toLowerCase() === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACTIVE.name.toLowerCase()
            || status.toLowerCase() === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase()
            || status.toLowerCase() === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.name.toLowerCase();
    };
    InfluencerChatComponent.prototype.buildContactPermissionRequest = function (conversation) {
        var _this = this;
        var recipient;
        this.userService.getCurrentUserInfo().subscribe(function (item) {
            recipient = item.data;
            var message = "Contact permission requested by: " + recipient.fullName;
            var requestMessage = {
                id: _this.REQUEST_PERMISSION_MESSAGE_ID,
                conservationId: _this.conversation.id,
                activityAuthor: 'Achoo Influencer Platform',
                sender: {
                    id: _this.userService.getCompanyId(),
                    name: recipient.fullName,
                    company: null,
                    influencer: null,
                    lastSeenMessage: null,
                    user: null
                },
                content: message,
                type: 3 /* Invitation */,
                messageType: 'REQUESTED_PERMISSION',
                recipientName: recipient.fullName,
                sentTime: String(DateUtils.now().getTime())
            };
            conversation.messages.push(requestMessage);
            _this.messageList = conversation.messages;
        });
    };
    InfluencerChatComponent.prototype.buildAutoReplyMessage = function (sentTime) {
        if (this.hasAutoReplyMessage) {
            return;
        }
        var systemUser = {
            id: null,
            name: null,
            company: null,
            influencer: null,
            lastSeenMessage: null,
            user: {
                image: 'assets/images/email_circle.svg',
                fullName: 'Achoo Influencer Platform'
            }
        };
        var autoReplyMessage = {
            id: 1,
            conservationId: this.conversation.id,
            sender: systemUser,
            content: this.translate.instant('INFLUENCER.auto_reply_message'),
            type: 1 /* InComming */,
            recipientName: null,
            sentTime: String(sentTime + 1)
        };
        this.hasAutoReplyMessage = true;
        this.messageList.push(autoReplyMessage);
    };
    InfluencerChatComponent.prototype.sendMixpanel = function () {
        var actionSource;
        var params = {
            companyId: this.currentUserInfo.company.id,
            action: UserActionType.MESSAGE
        };
        if (this.isLandingPageMode) {
            actionSource = ActionSource.CAMPAIGN_LANDING_PAGE;
        }
        else if (this.isCommunicationPage) {
            actionSource = ActionSource.COMMUNICATION_PAGE;
        }
        else {
            actionSource = ActionSource.ACTIVITY_TAB;
        }
        params = Object.assign({}, params, {
            source: actionSource
        });
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CHAT, {
            type: this.userService.isInfluencer ? TargetType.INFLUENCER : TargetType.ADVERTISER,
            id: this.currentUserInfo.company.id,
            name: this.currentUserInfo.company.name,
        }, params, undefined, null);
    };
    InfluencerChatComponent.prototype.getSenderAvatar = function (message) {
        if (!message || !message.sender) {
            return null;
        }
        if (message.sender.influencer) {
            return message.sender.influencer.profileImage;
        }
        if (message.sender.user) {
            return message.sender.user.image;
        }
        return null;
    };
    InfluencerChatComponent.prototype.hasChangedConvo = function (previous, current) {
        if (!previous && !current) {
            return false;
        }
        if (!previous && current) {
            return current.id > 0;
        }
        if (previous && !current) {
            return previous.id > 0;
        }
        return previous.id !== current.id && current.id > 0;
    };
    InfluencerChatComponent.MAX_LENGTH_MESSAGE = 1048;
    return InfluencerChatComponent;
}());
export { InfluencerChatComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer-inbox/influencer-chat/influencer-chat.component.ts.pre-build-optimizer.js